const generateTelephone = (provider) => {
  if (provider.phone?.length > 0) {
    const { landline } = provider.phone[0]
    return landline || null
  }
  return null
}

export default generateTelephone
